import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Post from "../components/Post";
import { getPosts, getRealtimePosts } from "../utils/helper";
import CircularProgress from "@material-ui/core/CircularProgress";
import useDebounce from "src/hooks/use-debounce";
import { Typography } from "@material-ui/core";
import CustomDateTimePicker from "../components/CustomDateTimePicker";
import AutocompleteTextField from "../components/autocompleteTextField";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  filtersRoot: {
    flexGrow: 1,
  },
  textFieldRoot: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));

export default function ManualSetting({
  onClose,
  open,
  data = {},
  index,
  home,
}) {
  const classes = useStyles();
  const [filters, setFilters] = useState({
    sortBy: "newest",
    isDuplicated: false,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [currentPost, setCurrentPost] = useState(data ? data.post : null);
  const [openAfterExpiredSetting, setOpenAfterExpiredSetting] = useState(false);
  const [expiredAt, setExpiredAt] = useState(null);
  const [errorTime, setErrorTime] = useState(null);

  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const [autoGetBy, setAutoGetBy] = useState("newest");
  const [tags, setTags] = useState(data ? data.tags : []);
  const [category, setCategory] = useState(data ? data.category : null);
  const [duplicatePermission, setDuplicatePermission] = useState(
    data ? data.duplicatePermission : null
  );
  const [pageviewDuration, setPageviewDuration] = useState(
    data ? data.pageviewDuration : null
  );

  const handleFiltersChange = (objValue) => {
    const newFilters = {
      ...filters,
      ...objValue,
    };
    setFilters(newFilters);
  };

  const handleSelectPost = (post) => {
    setSelectedPost(post);
  };

  const _handleOnClose = ({ post }) => {
    const returnData = {
      ...data,
      type: post ? "manual" : data.type,
      autoGetBy,
      post,
      expiredAt: openAfterExpiredSetting ? expiredAt : null,
      tags: autoGetBy !== "realtime" ? tags : [],
      category: autoGetBy !== "realtime" ? category : null,
      duplicatePermission: duplicatePermission === "true",
      pageviewDuration:
        autoGetBy === "pageview" &&
        pageviewDuration !== "" &&
        parseInt(pageviewDuration, 10) >= 0
          ? parseInt(pageviewDuration, 10)
          : 1,
    };
    setExpiredAt(null);
    setOpenAfterExpiredSetting(false);
    setSelectedPost(null);
    setSearchTerm("");
    onClose(returnData);
  };

  const cancel = () => {
    setExpiredAt(null);
    setOpenAfterExpiredSetting(false);
    setSelectedPost(null);
    setSearchTerm("");
    onClose();
  };

  const save = () => {
    _handleOnClose({ post: selectedPost });
  };

  const getListPost = async () => {
    const inIds = [];

    if (filters.sortBy === "realtime") {
      const realtimePostsResponse = await getRealtimePosts();
      realtimePostsResponse.forEach((p) => {
        inIds.push(p.id);
      });
    }

    const ninIds = [];
    if(home.tiles){
      home.tiles.forEach((tile) => {
        if (tile.type === "manual" && tile.post) {
          ninIds.push(tile.post.id);
        }
        // fix lỗi nếu tile có nextPost bỏ nextPost vào not in list
        if (tile.type === "manual" && tile.nextPost) {
          ninIds.push(tile.nextPost.id);
        }
      });

    }
    
    const queryParams = {
      type: "da-dang",
      _sort: "publishedAt:desc",
      _start: 0,
      _limit: 40,
      editor_type_in : ['normal', 'mini', 'special'],
      pr_type: "0",
      ...(searchTerm && { _q: searchTerm }),
      ...(!filters.isDuplicated && {
        id_nin: ninIds,
      }),
      ...(filters.sortBy === "realtime" && {
        id_in: inIds,
      }),
      hidden_ne: true
    };

    setLoading(true);
    getPosts(queryParams).then((data) => {
      data.posts && setPosts(data.posts);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getListPost();
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    getListPost();
  }, [filters]);

  useEffect(() => {
    setCurrentPost(data ? data.post : null);
  }, [data]);

  useEffect(() => {
    setAutoGetBy(data && data.autoGetBy ? data.autoGetBy : "newest");
    setTags(data && data.tags ? data.tags : []);
    setPageviewDuration(
      data && data.pageviewDuration ? data.pageviewDuration : null
    );
    setDuplicatePermission(
      data && data.duplicatePermission ? data.duplicatePermission : false
    );
    if (open) {
      getListPost();
    }
  }, [open]);

  useEffect(() => {
    if (expiredAt) {
      const now = new Date();
      const compareTime = new Date(expiredAt).getTime() - now.getTime();
      if (compareTime < 0) {
        setErrorTime("Thời gian nhỏ hơn hiện tại.");
      } else {
        setErrorTime(null);
      }
    }
  }, [expiredAt]);

  return (
    <Dialog
      open={open}
      onClose={cancel}
      aria-labelledby="form-dialog-title"
      fullWidth={true}
      maxWidth="md"
    >
      <DialogTitle id="form-dialog-title">
        Vị trí {index + 1} - Cài đặt bài viết cố định
      </DialogTitle>
      <DialogContent dividers={true}>
        {openAfterExpiredSetting ? (
          <React.Fragment>
            {selectedPost && (
              <Typography variant="h5" gutterBottom>
                {selectedPost.title}
              </Typography>
            )}

            <CustomDateTimePicker
              selectedDate={expiredAt}
              setDate={setExpiredAt}
              error={errorTime}
            />

            {expiredAt && (
              <React.Fragment>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <FormControl component="fieldset" className="d-block mt-4">
                      <FormLabel component="legend">
                        Cài đặt bài viết xuất hiện sau đó. Theo:
                      </FormLabel>
                      <RadioGroup
                        aria-label="gender"
                        name="gender1"
                        value={autoGetBy}
                        onChange={(event) => setAutoGetBy(event.target.value)}
                      >
                        <FormControlLabel
                          value="newest"
                          control={<Radio />}
                          label="Mới nhất"
                        />
                        <FormControlLabel
                          value="pageview"
                          control={<Radio />}
                          label="Top View"
                        />
                        <FormControlLabel
                          value="realtime"
                          control={<Radio />}
                          label="Realtime"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <AutocompleteTextField
                      label="Nhập tags (nếu có)"
                      setValue={setTags}
                      defaultValue={data && data.tags ? data.tags : []}
                      endpoint="tags"
                      disabled={autoGetBy === "realtime"}
                      multiple={true}
                    />

                    <AutocompleteTextField
                      label="Nhập category (nếu có)"
                      setValue={setCategory}
                      defaultValue={
                        data && data.category ? data.category : null
                      }
                      endpoint="categories"
                      labelField="name"
                      className="mt-4"
                      disabled={autoGetBy === "realtime"}
                    />

                    <form className="mt-4" noValidate autoComplete="off">
                      <TextField
                        disabled={autoGetBy !== "pageview"}
                        id="time-filter"
                        label="Thời gian (ngày trước)"
                        defaultValue={pageviewDuration ? pageviewDuration : 1}
                        onChange={(event) =>
                          setPageviewDuration(event.target.value)
                        }
                        type="number"
                        variant="outlined"
                        error={
                          pageviewDuration === "" ||
                          parseInt(pageviewDuration, 10) <= 0
                        }
                      />
                    </form>
                    {data && data.showDuplicationSetting && (
                      <FormControl className="mt-4" style={{ width: "300px" }}>
                        <InputLabel id="duplicate-permission">
                          Được trùng các bài khác
                        </InputLabel>
                        <Select
                          labelId="duplicate-permission-label"
                          id="duplicate-permission"
                          value={duplicatePermission}
                          onChange={(event) =>
                            setDuplicatePermission(event.target.value)
                          }
                          label="Được trùng các bài khác"
                          disabled={autoGetBy === "realtime"}
                        >
                          <MenuItem value={false}>Không trùng</MenuItem>
                          <MenuItem value={true}>Trùng</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  </Grid>
                </Grid>
              </React.Fragment>
            )}
          </React.Fragment>
        ) : (
          <div style={{ height: "70vh" }}>
            <form
              className={classes.textFieldRoot}
              noValidate
              autoComplete="off"
            >
              <div>
                <TextField
                  id="standard-basic"
                  label="Tìm kiếm"
                  onChange={(event) => {
                    setSearchTerm(event.target.value);
                  }}
                />
              </div>
            </form>
            <div className={classes.filtersRoot}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={3}>
                  <FormControl className={classes.formControl}>
                    <InputLabel id="demo-simple-select-outlined-label">
                      Sếp theo
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={filters.sortBy}
                      onChange={(event) =>
                        handleFiltersChange({ sortBy: event.target.value })
                      }
                      label="Sếp theo"
                    >
                      <MenuItem value="newest">Mới nhất</MenuItem>
                      <MenuItem value="realtime">Realtime</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3}>
                  <FormControl className={classes.formControl}>
                    <InputLabel id="select-duplicated-post">
                      Bài trùng
                    </InputLabel>
                    <Select
                      labelId="select-duplicated-post-label"
                      id="select-duplicated-post"
                      value={filters.isDuplicated}
                      onChange={(event) =>
                        handleFiltersChange({
                          isDuplicated: event.target.value,
                        })
                      }
                      label="Bài trùng"
                    >
                      <MenuItem value="false">Không trùng</MenuItem>
                      <MenuItem value="true">Trùng</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </div>

            {!loading &&
              posts.map((post, index) => (
                <Post
                  key={`post-${index}`}
                  post={post}
                  selectPost={handleSelectPost}
                  currentPost={currentPost}
                  selectedPost={selectedPost}
                  setOpenAfterExpiredSetting={setOpenAfterExpiredSetting}
                />
              ))}

            {posts.length === 0 && !loading && (
              <Typography variant="h6" gutterBottom>
                Không có bài viết!
              </Typography>
            )}

            {loading && (
              <div className="d-flex justify-content-center mt-4">
                <CircularProgress />
              </div>
            )}
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={cancel} color="primary">
          Hủy
        </Button>
        <Button onClick={save} color="primary" disabled={!selectedPost || errorTime}>
          Lưu
        </Button>
      </DialogActions>
    </Dialog>
  );
}
